module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/eye_sm-6613fa5f4c634fd88f299240b0ccd93e.jpg";